import AppConfig from '@app/libs/reactPdfJs/constants/AppConfig';
import { PdfAction } from '@app/libs/reactPdfJs/store/actions';
import {
  PDF_CLEAR_ALL_STATE,
  PDF_SCALE_CHANGE,
  PDF_SCALE_NORMALIZE,
} from '@app/libs/reactPdfJs/store/actionTypes';

export type PdfScaleState = number;

const initialState: PdfScaleState = AppConfig.scale.defaultScale;

export default function reducer(state: PdfScaleState = initialState, action: PdfAction) {
  switch (action.type) {
    case PDF_CLEAR_ALL_STATE:
      return state;
    case PDF_SCALE_CHANGE:
      return action.payload;
    case PDF_SCALE_NORMALIZE:
      return action.payload.defaultScale;
    default:
      return state;
  }
}
